<script>
export default {
    data() {
        return {
            automation: {
                name: 'Reminders',
                img: 'reminders'
            },
            automations: [
                {
                    name: 'Reminders',
                    img: 'reminders'
                },
                {
                    name: 'Recurring Tasks',
                    img: 'recurring-tasks'
                },
                {
                    name: 'If-Then Rules',
                    img: 'if-then'
                },
                {
                    name: 'Form Submitted',
                    img: 'form-submitted'
                },
                {
                    name: 'Button',
                    img: 'button'
                },
            ]
        };
    },
    methods:{
        goToStep(automation)
        {
            this.automation = automation;
        }
    },
};
</script>


// WEBPACK FOOTER //
// resources/js/frontend/components/AutomationsSlider.vue